export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Luxurious%20fashion%20retail%20display%20featuring%20arranged%20designer%20handbags%20elegant%20shoes%20and%20silk%20accessories%20on%20warm%20amber-lit%20shelving%2C%20upscale%20boutique%20interior%20with%20marble%20flooring%20brass%20fixtures%20and%20soft%20warm%20spotlighting%2C%20rich%20textural%20variety%20of%20leather%20suede%20silk%20and%20metal%2C%20sophisticated%20high-end%20shopping%20environment%20with%20dramatic%20depth%20of%20field%20and%20golden%20hour%20ambiance&width=1800&height=800&seq=cta-bg-v4-luxury-retail&orientation=landscape)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/35 to-black/55 z-[1]"></div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
          <div className="flex-1">
            <h2 className="font-heading text-4xl md:text-6xl font-bold text-white leading-tight">
              Sugargoo Spreadsheet
            </h2>
            <p className="mt-4 text-white/80 text-[15px] md:text-[16px] max-w-md leading-relaxed font-medium">
              Ready to explore the full collection? Visit our main platform for the complete sugargoo spreadsheet experience with thousands of curated product links.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-4">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-4 bg-accent-500 text-white font-bold text-[14px] rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2 shadow-lg shadow-accent-500/30"
            >
              Sugargoo Spreadsheet
              <span className="w-7 h-7 rounded-full bg-white/20 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-xs"></i>
              </span>
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-4 bg-white text-foreground-950 font-bold text-[14px] rounded-full hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              Buy It Now
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}